/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
export const USER_ABSENCE_GRID_CODE = 'user-absence';
export const USER_ABSENCE_OVERVIEW_GRID_CODE = 'user-absence-overview';
